<script>
    import {binaryDataUrl} from "../urls";
    import DownloadIcon from "../icons/DownloadIcon.svelte";
    import RefreshIcon from "../icons/RefreshIcon.svelte";
    import {createEventDispatcher} from "svelte";

    export let existingFilename;
    export let existingId;
    export let value;

    let preview;
    let newFilename;

    const dispatch = createEventDispatcher();

    function handleFile(file) {
        dispatch('change', {
            data: file,
        });
        const reader = new FileReader();
        reader.addEventListener("load", function () {
            preview = reader.result;
        });
        reader.readAsDataURL(file);
    }

    function onFileChange(event) {
        const file = event.target.files[0];

        preview = null;
        newFilename = file.name;

        if (file) {
            event.target.value = ''
            handleFile(file)
        }
    }

    function onDrop(event) {
        handleFile(event.target.file)
    }

    function onReplace(event) {
        input.click()
    }

    let input;
    let isHovering;
</script>

<div
     on:mouseover={() => (isHovering = true)}
     on:mouseleave={() => (isHovering = false)}
     class="relative items-center border-gray-200 border-2 border-opacity-0 hover:border-opacity-100 hover:shadow-lg rounded-md"
>
    {#if preview}
        <img src={preview} title={newFilename} alt={newFilename}/>
    {:else if existingId}
        <img src={`${binaryDataUrl(existingId)}`} title={existingFilename}
             alt="{existingFilename}"/>
    {:else}
        <span>Set image...</span>
    {/if}
    {#if isHovering}
        <div
            class="absolute justify-center flex flex-col z-10">
            <div class="rounded-md flex items-center justify-items-stretch">
                <span title="Replace" class="icon-holder rounded-l-md" on:click={()=>input.click()}>
                    <RefreshIcon/>
                </span>
                {#if existingId}
                    <a title="Download" class="icon-holder" href={binaryDataUrl(existingId)}>
                        <DownloadIcon/>
                    </a>
                {/if}
            </div>
        </div>
    {/if}
    <input type="file" bind:this={input} accept="image/png" title="" class="hidden"
           on:change={(event) => onFileChange(event)}/>
</div>

<style>
    .icon-holder {
        @apply p-1 cursor-pointer inline-flex items-center text-sm text-gray-900 bg-gray-200 border border-r-0 border-gray-300 dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600
    }
</style>